module.exports = __webpack_public_path__ + "static/img/14000613.663fdace.png";